let FirstLastName = () => {
  return (input) => {
  	let words = input.split(' ');
  	return words.length > 1 ? words[0] + ' ' + words[words.length -1] : words[0];
  }
};

FirstLastName.$inject = [];

export default FirstLastName;



// WEBPACK FOOTER //
// ./client/app/common/filters/first-last-name.filter.js